import { render, staticRenderFns } from "./Salir.vue?vue&type=template&id=d12322e4&scoped=true&"
import script from "./Salir.vue?vue&type=script&lang=js&"
export * from "./Salir.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d12322e4",
  null
  
)

export default component.exports